import type { ColDef } from '../../components/DataGrid/types';
import { listFormatter, zeroFormatter } from './renderers';

export const columnDefs: ColDef[] = [
  {
    field: 'artist',
    headerName: 'Artist',
    width: 300,
    sortable: true,
    hide: false,
  },
  {
    field: 'cleanTitle',
    headerName: 'Clean Title',
    width: 300,
    sortable: true,
    hide: false,
  },
  {
    field: 'repertoireOwnerMostCommon',
    headerName: 'Repertoire Owner (most common)',
    width: 120,
    sortable: true,
    hide: true,
  },
  {
    field: 'isrcList',
    headerName: 'ISRC List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'gpidList',
    headerName: 'GPID List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    headerName: 'WMG1 Label',
    field: 'wmg1Labels',
    hide: true,
  },
  {
    field: 'majorLabelList',
    headerName: 'Major Label List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'presentationLabelList',
    headerName: 'Presentation Label List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'repertoireOwnerList',
    headerName: 'Repertoire Owner List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'majorGenreDescList',
    headerName: 'Major Genre List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'lastCompleteWeekStreams',
    headerName: 'Streams #: Last Complete Week',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: true,
    sortable: true,
  },
  {
    field: 'immersiveCnt',
    headerName: 'Immersive',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'spedUpCnt',
    headerName: 'Sped Up',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'slowedDownCnt',
    headerName: 'Slowed Down',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'acousticCnt',
    headerName: 'Acoustic',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'instrumentalCnt',
    headerName: 'Instrumental',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'remixCnt',
    headerName: 'Remix',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'remasterCnt',
    headerName: 'Remaster',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'liveCnt',
    headerName: 'Live',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'exclusiveCnt',
    headerName: 'Exclusive',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: true,
    sortable: true,
  },
  {
    field: 'amendedCnt',
    headerName: 'Amended',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'pianoCnt',
    headerName: 'Piano',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: true,
    sortable: true,
  },
  {
    field: 'stringsCnt',
    headerName: 'Strings',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: true,
    sortable: true,
  },
  {
    field: 'demoCnt',
    headerName: 'Demo',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'featuredCnt',
    headerName: 'Featured',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'acapellaCnt',
    headerName: 'Acapella',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'officialVideoCnt',
    headerName: 'Official Video',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'lyricVideoCnt',
    headerName: 'Lyric Video',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'anyOtherVideoCnt',
    headerName: 'Any Other Video',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  {
    field: 'ringtoneCnt',
    headerName: 'Ringtone',
    width: 120,
    valueFormatter: zeroFormatter,
    hide: false,
    sortable: true,
  },
  // {
  //   field: 'ringbacktoneCnt',
  //   headerName: 'Ringbacktone',
  //   width: 120,
  //   valueFormatter: zeroFormatter,
  //   hide: false,
  //   sortable: true,
  // },
];
